import { forwardRef } from 'react';
import type { IconButtonProps } from './IconButton.types';
import './IconButton.scss';

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { size = 'md', variant = 'ghost', className, type, children, ...rest },
  ref,
) {
  const classes = ['icon-button', `icon-button--${size}`, `icon-button--${variant}`, className || '']
    .filter(Boolean)
    .join(' ');
  return (
    <button ref={ref} type={type || 'button'} className={classes} {...rest}>
      <span className="icon-button__icon" aria-hidden="true">
        {children}
      </span>
    </button>
  );
});

export default IconButton;
